export class GetUserName {
  static readonly type = '[Shared] Get current user name';

  constructor(public payload: string) {
  }
}
